import { useEffect, useRef, useState } from 'react';
import { type CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

function useChangedRefinements(currentRefinements: CurrentRefinementsConnectorParamsItem[]) {
  const initialRefinementsRef = useRef<CurrentRefinementsConnectorParamsItem[]>([]);
  const [changedRefinements, setChangedRefinements] = useState<CurrentRefinementsConnectorParamsItem[]>([]);

  useEffect(() => {
    if (initialRefinementsRef.current.length === 0) {
      initialRefinementsRef.current = currentRefinements;
    }

    const changes = currentRefinements.filter(current => {
      const initial = initialRefinementsRef.current.find(init => init.attribute === current.attribute);

      // If this refinement attribute wasn't present in the initial state,
      // consider it as a new refinement that was added
      if (!initial) {
        return true;
      }

      // Check if any refinement value or operator has changed by comparing each one
      // with its corresponding initial refinement at the same index.
      return current.refinements.some((currentRefinement, index) => {
        const initialRefinement = initial.refinements[index];
        return (
          !initialRefinement ||
          currentRefinement.value !== initialRefinement.value ||
          currentRefinement.operator !== initialRefinement.operator
        );
      });
    });

    setChangedRefinements(changes);
  }, [currentRefinements]);

  return changedRefinements;
}

export default useChangedRefinements;
